export * from './vertical-config.js';
export * from './verticals.js';
import { z } from 'zod';
import { verticalConfig } from './vertical-config.js';
/** Environment configuration: typed, validated at boot, fail fast (CLAUDE.md §3.4). */
export const envConfig = z.object({
    GARNET_ENV: z.enum(['local', 'ci', 'staging', 'production']),
    GARNET_CELL: z.enum(['eu', 'uk', 'in', 'ae']),
    DATABASE_URL: z.string().url(),
    OBJECT_STORE_ENDPOINT: z.string().url(),
    REDIS_URL: z.string().url(),
    OPENSEARCH_URL: z.string().url().optional(),
    CORE_SERVING_URL: z.string().url().default('http://localhost:4100'),
});
export function loadEnv(source = process.env) {
    const parsed = envConfig.safeParse(source);
    if (!parsed.success) {
        const missing = parsed.error.issues.map((i) => i.path.join('.')).join(', ');
        throw new Error(`invalid environment configuration: ${missing}`);
    }
    return parsed.data;
}
export class VerticalRegistry {
    byVertical = new Map();
    register(config) {
        const valid = verticalConfig.parse(config);
        if (this.byVertical.has(valid.vertical)) {
            throw new Error(`vertical ${valid.vertical} already registered`);
        }
        this.byVertical.set(valid.vertical, valid);
    }
    get(vertical) {
        const config = this.byVertical.get(vertical);
        if (!config)
            throw new Error(`no CONFIG registered for vertical ${vertical}`);
        return config;
    }
    list() {
        return [...this.byVertical.values()];
    }
}
//# sourceMappingURL=index.js.map